@import '../../style/index';

:host {
  display: block;

  .loader {
    display: flex;
    justify-content: center;
    border-radius: 100%;
    position: relative;
    margin: var(--spacings-xxl) auto;

    &--noMargin {
      margin: 0;
    }
  }

  .loader::before,
  .loader::after {
    content: '';
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    border-radius: 100%;
    border: 5px solid transparent;
    border-top-color: var(--colors-grey-dark);
    box-sizing: border-box;
  }

  .loader::before {
    z-index: 100;
    animation: spin linear 1s infinite;
  }

  .loader::after {
    border: 5px solid var(--colors-grey-medium);
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
      transform: rotate(0deg);
      transform: rotate(0deg);
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
      transform: rotate(360deg);
      transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
}
